function fixNumber(n, f = 2) {
  return n === (n | 0) ? n : Number(n.toFixed(f))
}

export default fixNumber



// WEBPACK FOOTER //
// ./src/services/utils/fixNumber.js